import React from 'react';
import { T } from '../../utils/theme';
import api from '../../services/api';
import { UserPlus, ArrowLeft, Loader } from 'lucide-react';

const CustomerStep = ({ branchId, initialPhone, onCreated, onBack }) => {
  const [name, setName] = React.useState('');
  const [phone, setPhone] = React.useState(initialPhone || '');
  const [birthDate, setBirthDate] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (initialPhone) setPhone(initialPhone);
  }, [initialPhone]);

  const create = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.post('/kiosk/customers', { name, phone, birthDate, branchId });
      onCreated(res);
    } catch (e) {
      setError(e?.response?.data?.message || 'Nao foi possivel concluir o cadastro. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const avisoErro = error && (
    <div style={{ background: 'rgba(255,59,48,0.12)', color: T.danger, padding: '12px 16px', borderRadius: 14, fontSize: 14, fontWeight: 500, marginBottom: 14, textAlign: 'center' }}>{error}</div>
  );

  const inputStyle = {
    width: '100%', padding: '16px 18px', borderRadius: 16,
    background: T.fill, border: `1px solid ${T.separator}`,
    color: T.label, fontSize: 17, fontFamily: 'inherit', outline: 'none',
  };

  return (
    <div style={{
      minHeight: '100%', display: 'flex', flexDirection: 'column',
      background: T.bg,
    }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 20, margin: '0 auto 20px',
            background: 'rgba(191,90,242,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <UserPlus size={28} color={T.purple} />
          </div>
          <div style={{ fontSize: 28, fontWeight: 700, color: T.label, letterSpacing: '-0.025em' }}>Cadastro rapido</div>
          {avisoErro}
          <div style={{ fontSize: 16, color: T.label2, marginTop: 6 }}>Preencha seus dados para continuar</div>
        </div>

        <div style={{
          background: '#fff', borderRadius: 20, padding: 24,
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
          display: 'flex', flexDirection: 'column', gap: 14,
        }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: T.label2, marginBottom: 6 }}>Nome completo *</label>
            <input placeholder="Ex: Joao Silva" value={name} onChange={e => setName(e.target.value)} disabled={loading} style={inputStyle} autoFocus />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: T.label2, marginBottom: 6 }}>Telefone *</label>
            <input placeholder="(00) 00000-0000" value={phone} onChange={e => setPhone(e.target.value)} disabled={loading} style={inputStyle} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: T.label2, marginBottom: 6 }}>Data de nascimento</label>
            <input type="date" value={birthDate} onChange={e => setBirthDate(e.target.value)} disabled={loading} style={inputStyle} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button onClick={onBack} disabled={loading} style={{
            flex: 1, padding: 16, borderRadius: 16, border: `1px solid ${T.separator}`,
            background: '#fff', color: T.label, fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          }}>
            <ArrowLeft size={16} /> Voltar
          </button>
          <button onClick={create} disabled={loading || !name || !phone} style={{
            flex: 1, padding: 16, borderRadius: 16, border: 'none',
            background: (!name || !phone || loading) ? T.fill2 : T.accent, color: '#fff',
            fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: (!name || !phone || loading) ? 'not-allowed' : 'pointer',
            boxShadow: (!name || !phone || loading) ? 'none' : '0 4px 14px rgba(10,132,255,0.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          }}>
            {loading ? <><Loader size={16} className="animate-spin" /> Cadastrando...</> : 'Cadastrar'}
          </button>
        </div>
      </div>

      <div style={{ textAlign: 'center', padding: '16px 0 24px', fontSize: 12, color: T.label3 }}>Feito por Barbx</div>
    </div>
  );
};

export default CustomerStep;
